<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- Header Banner Principal -->
    <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden">
      <div class="bg-primary text-white q-pa-md row items-center justify-between">
        <div class="row items-center">
          <q-icon name="key" size="md" class="q-mr-sm" />
          <div>
            <div class="text-h6 text-weight-bold">Gestión Centralizada de Licencias</div>
            <div class="text-caption text-blue-2">Administración de clientes, vinculación multiempresa y soporte técnico</div>
          </div>
        </div>
        <q-btn
          color="white"
          text-color="primary"
          icon="add"
          label="Nueva Licencia"
          unelevated
          rounded
          class="text-weight-bold"
          @click="abrirNuevaLicencia"
        />
      </div>

      <!-- Filtros de Búsqueda -->
      <q-card-section class="q-pa-md">
        <div class="row q-col-gutter-md items-center">
          <div class="col-12 col-sm-9 col-md-10">
            <q-input
              v-model="buscar1"
              outlined
              dense
              placeholder="Buscar por RUC o Razón Social..."
              clearable
              @keyup.enter="buscarLicencia"
            >
              <template v-slot:prepend>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-sm-3 col-md-2">
            <q-btn
              color="primary"
              icon="search"
              label="Buscar"
              class="full-width text-weight-bold"
              unelevated
              @click="buscarLicencia"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Tabla Quasar con Estilo Elegante -->
    <q-card class="shadow-2 rounded-borders">
      <q-table
        :data="listaLicencias"
        :columns="columns"
        row-key="license_key"
        :loading="loading"
        :grid="$q.screen.xs"
        :pagination.sync="pagination"
        flat
        bordered
        class="licencias-table"
        no-data-label="No se encontraron licencias registradas"
      >
        <!-- Slot Tipo de Licencia -->
        <template v-slot:body-cell-tipo_licencia="props">
          <q-td :props="props">
            <q-chip
              dense
              text-color="white"
              :color="getTipoColor(props.value)"
              class="text-weight-bold text-caption"
            >
              {{ props.value || 'CONTABLE' }}
            </q-chip>
          </q-td>
        </template>

        <!-- Slot Cantidad de Empresas (Multiempresa) -->
        <template v-slot:body-cell-cantidad_empresas="props">
          <q-td :props="props" class="text-center">
            <q-chip
              dense
              color="indigo"
              text-color="white"
              class="text-weight-bold cursor-pointer"
              clickable
              @click="abrirEmpresas(props.row)"
            >
              <q-icon name="business" size="xs" class="q-mr-xs" />
              {{ props.value || 0 }} Empresas
            </q-chip>
          </q-td>
        </template>

        <!-- Slot Expiración -->
        <template v-slot:body-cell-expiry_date="props">
          <q-td :props="props">
            <div class="row items-center q-gutter-xs">
              <span>{{ formatDate(props.value) }}</span>
              <q-badge
                v-if="isExpired(props.value)"
                color="negative"
                label="Vencido"
                class="q-ml-xs"
              />
            </div>
          </q-td>
        </template>

        <!-- Slot Acciones -->
        <template v-slot:body-cell-actions="props">
          <q-td :props="props" class="text-right">
            <q-btn
              flat
              round
              color="indigo"
              icon="business"
              size="sm"
              @click="abrirEmpresas(props.row)"
            >
              <q-tooltip>Vincular / Ver Empresas</q-tooltip>
            </q-btn>
            <q-btn
              flat
              round
              color="primary"
              icon="edit"
              size="sm"
              @click="editar(props.row)"
            >
              <q-tooltip>Editar Licencia</q-tooltip>
            </q-btn>
            <q-btn
              flat
              round
              color="grey-7"
              icon="visibility"
              size="sm"
              @click="detalle(props.row.ruc, props.row.license_key)"
            >
              <q-tooltip>Ver Detalle</q-tooltip>
            </q-btn>
            <q-btn
              flat
              round
              color="negative"
              icon="delete"
              size="sm"
              @click="eliminar(props.row.ruc, props.row.license_key)"
            >
              <q-tooltip>Eliminar Licencia</q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </q-card>

    <!-- Modal Formulario de Licencias -->
    <license-form
      v-model="dialog"
      :edit-mode="editMode"
      :form-data="form"
      @save="guardarLicencia"
      @close="dialog = false"
    />

    <!-- Modal Vinculación de Empresas (Multiempresa) -->
    <licencia-empresas-modal
      :DialogEmpresas="dialogEmpresas"
      :Licencia="licenciaSeleccionada"
      @CerrarModal="dialogEmpresas = false"
      @EmpresasActualizadas="listar"
    />
  </q-page>
</template>

<script>
import axios from "axios";
import LicenseForm from "./LicenseForm.vue";
import LicenciaEmpresasModal from "./LicenciaEmpresasModal.vue";

export default {
  name: "LicenciasListaPage",
  components: { LicenseForm, LicenciaEmpresasModal },
  data() {
    return {
      pagination: { rowsPerPage: 50 },
      numerosPaginas: 1,
      totalPaginas: 0,
      tamanoPagina: 50,
      buscar1: "",
      listaLicencias: [],
      loading: false,
      dialog: false,
      dialogEmpresas: false,
      editMode: false,
      licenciaSeleccionada: {},
      form: {
        ruc: "",
        company_name: "",
        name: "",
        business_type: "",
        employee_count: 0,
        machine_id: "",
        expiry_date: "",
        license_key: "",
        tipo_licencia: "CONTABLE",
        is_active: false,
        celular: "",
        correo_electronico: "",
        estado: "activo",
      },
      columns: [
        { name: "ruc", label: "RUC / DNI", field: "ruc", align: "left", sortable: true },
        { name: "company_name", label: "Razón Social / Cliente", field: "company_name", align: "left", sortable: true },
        { name: "name", label: "Contacto", field: "name", align: "left" },
        { name: "license_key", label: "Clave de Licencia", field: "license_key", align: "center" },
        { name: "tipo_licencia", label: "Tipo Licencia", field: "tipo_licencia", align: "center" },
        { name: "cantidad_empresas", label: "Empresas", field: row => row.cantidad_empresas || 0, align: "center", sortable: true },
        { name: "expiry_date", label: "Fin de Soporte", field: "expiry_date", align: "center", sortable: true },
        { name: "estado", label: "Estado", field: "estado", align: "center" },
        { name: "celular", label: "Celular", field: "celular", align: "left" },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  created() {
    this.listar();
  },
  methods: {
    getTipoColor(tipo) {
      switch (tipo) {
        case "DEMO": return "warning";
        case "FULL": return "deep-purple";
        case "COMERCIAL": return "teal";
        case "PLANILLA": return "blue";
        default: return "primary";
      }
    },
    abrirEmpresas(row) {
      this.licenciaSeleccionada = { ...row };
      this.dialogEmpresas = true;
    },
    async listar() {
      this.loading = true;
      try {
        const response = await axios.post("ApiWeb/LicencesListarTodo.php", {
          pagina: this.numerosPaginas,
          tamanoPagina: this.tamanoPagina,
        });
        if (!response.data.error) {
          this.listaLicencias = response.data.data || [];
          this.totalPaginas = response.data.cantidad || 0;
        } else {
          this.notificar(response.data.mensaje, "negative");
        }
      } catch (error) {
        this.notificar("Error al cargar licencias", "negative");
      } finally {
        this.loading = false;
      }
    },
    async buscarLicencia() {
      this.loading = true;
      try {
        const response = await axios.post("ApiWeb/LicencesListar.php", {
          ruc: this.buscar1,
          company_name: this.buscar1,
          pagina: this.numerosPaginas,
          tamanoPagina: this.tamanoPagina,
        });
        if (!response.data.error) {
          this.listaLicencias = response.data.data || [];
          this.totalPaginas = response.data.cantidad || 0;
        } else {
          this.notificar(response.data.mensaje, "negative");
        }
      } catch (error) {
        this.notificar("Error al buscar licencias", "negative");
      } finally {
        this.loading = false;
      }
    },
    abrirNuevaLicencia() {
      this.editMode = false;
      this.form = {
        ruc: "",
        company_name: "",
        name: "",
        business_type: "",
        employee_count: 0,
        machine_id: "",
        expiry_date: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0],
        license_key: this.generateLicenseKey(),
        tipo_licencia: "CONTABLE",
        is_active: true,
        celular: "",
        correo_electronico: "",
        estado: "activo",
      };
      this.dialog = true;
    },
    editar(row) {
      this.form = {
        ...row,
        expiry_date: row.expiry_date
          ? new Date(row.expiry_date).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0],
        tipo_licencia: row.tipo_licencia || "CONTABLE",
        is_active: Boolean(row.is_active),
      };
      this.editMode = true;
      this.dialog = true;
    },
    detalle(ruc, license_key) {
      this.$router.push(`/aveo/Licencia/Detalle/${ruc}/${license_key}`);
    },
    async eliminar(ruc, license_key) {
      if (confirm("¿Está seguro de eliminar esta licencia?")) {
        try {
          const response = await axios.post("ApiWeb/LicencesEliminar.php", {
            ruc,
            license_key,
          });
          if (!response.data.error) {
            this.listar();
            this.notificar("Licencia eliminada", "positive");
          } else {
            this.notificar(response.data.mensaje, "negative");
          }
        } catch (error) {
          this.notificar("Error al eliminar licencia", "negative");
        }
      }
    },
    async guardarLicencia(formData) {
      const url = this.editMode
        ? "ApiWeb/LicencesEditar.php"
        : "ApiWeb/LicencesAgregar.php";
      try {
        const response = await axios.post(url, formData, {
          headers: { "Content-Type": "application/json" },
        });
        if (!response.data.error) {
          this.listar();
          this.dialog = false;
          this.notificar(
            this.editMode ? "Licencia actualizada" : "Licencia creada",
            "positive"
          );
        } else {
          this.notificar(response.data.mensaje, "negative");
        }
      } catch (error) {
        this.notificar("Error al guardar licencia", "negative");
      }
    },
    generateLicenseKey() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let key = "";
      for (let i = 0; i < 20; i++) {
        if (i > 0 && i % 5 === 0) key += "-";
        key += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return key;
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("es-PE");
    },
    isExpired(date) {
      if (!date) return false;
      return new Date(date) < new Date();
    },
    notificar(mensaje, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: mensaje,
          color: color,
          position: "top-right",
          timeout: 3000,
        });
      } else {
        alert(mensaje);
      }
    },
  },
};
</script>

<style scoped>
.licencias-table {
  border-radius: 8px;
}
</style>